"use strict"

import _ from "lodash"
import angular from "angular"
import async from "async"

import Promise from "bluebird"

import { getDefaultWeight, kStandardLabels } from "../../../components/counter-label"
import { getColors } from "../../../components/util/colors"
import { matchText } from "common-library/utils/matchText.js"
import { getCountryCodeFromTimezone } from "../../../components/countryfromtz"
import { DateTime } from "luxon"

const storeFormCtrl = function ($scope) {
  return {
    abnTimePeriod: {
      calMinute(time) {
        return parseInt(time.hour) * 60 + parseInt(time.minute)
      },

      isWithinBizHours() {
        const { abnTimePeriod } = $scope.form.schedule
        if (!abnTimePeriod.active) {
          return true
        }
        if (!$scope.form.schedule.businessHours.active) {
          return true
        }

        let times = [
          { id: 0, name: "BO", minute: this.calMinute($scope.open) },
          { id: 1, name: "MO", minute: this.calMinute(abnTimePeriod.open) },
          { id: 2, name: "MC", minute: this.calMinute(abnTimePeriod.close) },
          { id: 3, name: "BC", minute: this.calMinute($scope.close) },
        ]
        times = _.sortBy(times, ["minute", "id"])

        let inHours = true
        times.forEach(function (t, i, array) {
          if (array[(i + 1) % array.length].id !== (t.id + 1) % array.length) {
            return (inHours = false)
          }
        })

        return inHours
      },

      isValid() {
        const { abnTimePeriod } = $scope.form.schedule
        const { active } = abnTimePeriod
        const openHour = parseInt(abnTimePeriod.open.hour)
        const openMinute = parseInt(abnTimePeriod.open.minute)
        const closeHour = parseInt(abnTimePeriod.close.hour)
        const closeMinute = parseInt(abnTimePeriod.close.minute)
        if (
          (active && openHour === 24 && openMinute > 0) ||
          (closeHour === 24 && closeMinute > 0) ||
          (openHour === closeHour && openMinute === closeMinute)
        ) {
          return false
        } else {
          return true
        }
      },

      handleChange() {
        const { abnTimePeriod } = $scope.form.schedule
        if (abnTimePeriod.open.hour === "24") {
          abnTimePeriod.open.minute = "00"
        }
        if (abnTimePeriod.close.hour === "24") {
          abnTimePeriod.close.minute = "00"
        }
        if (
          abnTimePeriod.open.hour === abnTimePeriod.close.hour &&
          abnTimePeriod.open.minute === abnTimePeriod.close.minute
        ) {
          return $scope.form_create.abnTimePeriod.$setValidity("AbnTimePeriod", false)
        } else if (!this.isWithinBizHours()) {
          return $scope.form_create.abnTimePeriod.$setValidity("AbnTimePeriod", false)
        } else {
          return $scope.form_create.abnTimePeriod.$setValidity("AbnTimePeriod", true)
        }
      },

      toForm(value) {
        let closeMinute, openMinute
        if (!$scope.form) {
          $scope.form = {}
        }
        let openHour = "11"
        let closeHour = "17"
        if (!value || !value.active || value.dayOfWeek.length <= 0) {
          const { schedule } = $scope.form
          if (
            schedule &&
            schedule.businessHours.active &&
            schedule.businessHours.dayOfWeek &&
            schedule.businessHours.dayOfWeek.length > 0
          ) {
            openHour = parseInt(schedule.businessHours.dayOfWeek[0].open.split(":")[0]) + 1
            closeHour = parseInt(schedule.businessHours.dayOfWeek[0].close.split(":")[0]) - 1
            if (openHour > 24) {
              openHour = 0
            }
            if (closeHour < 0) {
              closeHour = 24
            }
            openHour = `${openHour}`.padStart(2, "0")
            closeHour = `${closeHour}`.padStart(2, "0")
          }

          return {
            active: false,
            open: {
              hour: openHour,
              minute: "00",
            },
            close: {
              hour: closeHour,
              minute: "00",
            },
          }
        }
        ;[openHour, openMinute] = Array.from(value.dayOfWeek[0].open.split(":"))
        ;[closeHour, closeMinute] = Array.from(value.dayOfWeek[0].close.split(":"))
        return {
          active: value.active,
          open: {
            hour: openHour,
            minute: openMinute,
          },
          close: {
            hour: closeHour,
            minute: closeMinute,
          },
        }
      },

      toValue(form) {
        return {
          active: form.active,
          dayOfWeek: [
            {
              open: `${form.open.hour}:${form.open.minute}`,
              close: `${form.close.hour}:${form.close.minute}`,
            },
          ],
        }
      },

      beforeSubmit() {
        const { form } = $scope
        const { abnTimePeriod } = form.schedule
        const isValid = this.isValid()
        if (isValid) {
          try {
            form.schedule.abnTimePeriod = this.toValue(abnTimePeriod)
          } catch (err) {
            console.warn(err)
            return false
          }
        } else {
          $scope.form.$valid = false
        }

        return isValid
      },

      afterSubmit() {
        const { form } = $scope
        const { abnTimePeriod } = form.schedule
        return (form.schedule.abnTimePeriod = this.toForm(abnTimePeriod))
      },
    },
  }
}

const App = angular.module("uCountitUiApp")
App.controller(
  "StoreCtrl",
  function (
    $scope,
    $rootScope,
    $filter,
    $window,
    $anchorScroll,
    $element,
    $sce,
    Auth,
    StoreAdminSrv,
    ApiSrv,
    Locale,
    IndustryCode,
    Upload,
    NgTableParams,
    ngDialog,
    FaceDeviceSrv,
    DateTimeSrv,
    StoreGroupSrv,
    HeaderSrv,
    me,
    GenderAge,
    UtilSrv,
    DataOperationSrv,
    CameraConfigSrv,
    CameraAdminSrv,
    CameraDeleteSrv,
    usSpinnerService,
    NewOverviewSrv,
    GeocodeSrv
  ) {
    let hideLoading
    $scope.vm = { company: null }

    // derived boolean to indicate whether the selected company has active aiReport
    Object.defineProperty($scope.vm, "isCompanyAiReportActive", {
      get() {
        return !!(this.company && this.company.aiReport && this.company.aiReport.active)
      },
      enumerable: true,
      configurable: true,
    })
    $scope.me = me
    if (me.isStore()) {
      return
    }

    $scope.roadNameAPIKey = $rootScope.globalConfig.roadNameAPIKey
    $scope.isLocalgrey = $rootScope.globalConfig.isLocalgrey
    $scope.isUkrt = $rootScope.globalConfig.isUkrt
    $scope.storeFormCtrl = storeFormCtrl($scope)
    $scope.languageList = Locale.getLangList()
    const supportedLocale = ["EN-US", "KO-KR"]
    $scope.supportedLanguageList = _.pickBy($scope.languageList, (lang) =>
      supportedLocale.includes(lang.code)
    )
    $scope.groupedIndustryOptions = IndustryCode.getFlatOptions()
    $scope.allIndustryOptions = IndustryCode.getCategorizedFlatOptions()
    const industryNames = new Map(
      $scope.allIndustryOptions.map(({ code, group, name }) => [
        code,
        IndustryCode.formatName(group, name),
      ])
    )
    $scope.vm.industryExpanded = false
    $scope.getIndustryName = (code) => industryNames.get(code) || code
    const categoryWidth = (options) =>
      `${
        Math.max(
          0,
          ...options.map(({ categoryName }) =>
            Array.from(categoryName).reduce(
              (width, char) => width + (/[\x00-\x7F]/.test(char) ? 0.5 : 1),
              0
            )
          )
        ) + 1
      }em`
    $scope.industryCategoryWidth = categoryWidth($scope.groupedIndustryOptions)

    const defaultDataRangeForFreq = function (freq) {
      if (freq === "weekly") return "last_7_days"
      if (freq === "monthly") return "previous_month"
      return "previous_day"
    }

    const emailScheduleMinutes = ["00", "10", "20", "30", "40", "50"]

    const snapMinuteToScheduleGrid = function (minute) {
      const allowed = [0, 10, 20, 30, 40, 50]
      const m = parseInt(minute, 10)
      if (isNaN(m)) return "00"
      const closest = allowed.reduce((best, x) => (Math.abs(x - m) < Math.abs(best - m) ? x : best))
      return String(closest).padStart(2, "0")
    }

    const formatEmailTimeEn12 = function (hour, minute) {
      let hh = parseInt(hour, 10)
      if (isNaN(hh) || hh < 0) hh = 10
      const mm = (minute || "00").padStart(2, "0")
      const ampm = hh >= 12 ? "PM" : "AM"
      let h12 = hh % 12
      if (h12 === 0) h12 = 12
      return `${h12}:${mm} ${ampm}`
    }

    const formatEmailTimeKo = function (hour, minute) {
      const hh = String(hour || "10").padStart(2, "0")
      const mm = (minute || "00").padStart(2, "0")
      return `${hh}:${mm}`
    }

    const buildEmailTimeSlotList = function () {
      const slots = []
      for (let h = 1; h <= 23; h++) {
        for (const m of emailScheduleMinutes) {
          const key = `${String(h).padStart(2, "0")}:${m}`
          slots.push({
            key,
            label: formatEmailTimeEn12(String(h).padStart(2, "0"), m),
          })
        }
      }
      return slots
    }

    $scope.emailTimeSlotList = buildEmailTimeSlotList()
    $scope.emailMonthDayNumbers = _.range(1, 32)

    const firstWeekdayIndexFromRow = function (weekdays) {
      if (!weekdays || !weekdays.length) return 1
      for (let i = 0; i <= 6; i++) {
        if (weekdays[i]) return i
      }
      return 1
    }

    const syncRowWeekdaysFromSingle = function (row) {
      const d = parseInt(row.weekdaySingle, 10)
      row.weekdays = [false, false, false, false, false, false, false]
      if (!isNaN(d) && d >= 0 && d <= 6) row.weekdays[d] = true
    }

    const parseDaysOfMonthStr = function (str) {
      if (!str || !str.trim()) return []
      return [
        ...new Set(
          str
            .split(",")
            .map((x) => parseInt(x.trim(), 10))
            .filter((n) => !isNaN(n) && n >= 1 && n <= 31)
        ),
      ].sort((a, b) => a - b)
    }

    const firstDayOfMonthFromStr = function (str) {
      const days = parseDaysOfMonthStr(str)
      return days.length ? days[0] : 1
    }

    const finalizeEmailScheduleRow = function (row) {
      const ranges = $scope.emailDataRangeOptions[row.frequency]
      if (ranges && ranges.indexOf(row.dataRange) === -1) {
        row.dataRange = defaultDataRangeForFreq(row.frequency)
      }

      let h = parseInt(row.hour, 10)
      if (isNaN(h) || h < 1 || h > 23) {
        h = 10
      }
      row.hour = String(h).padStart(2, "0")
      row.minute = snapMinuteToScheduleGrid(row.minute)
      row._timeKey = `${row.hour}:${row.minute}`

      let wd = parseInt(firstWeekdayIndexFromRow(row.weekdays), 10)
      if (isNaN(wd) || wd < 0 || wd > 6) {
        wd = 1
      }
      row.weekdaySingle = wd
      syncRowWeekdaysFromSingle(row)

      let dom = parseInt(firstDayOfMonthFromStr(row.daysOfMonthStr), 10)
      if (isNaN(dom) || dom < 1) {
        dom = 1
      }
      if (dom > 31) {
        dom = 31
      }
      row.dayOfMonthSingle = dom
      row.daysOfMonthStr = String(dom)

      if (row.dataRange === "custom") {
        applyDefaultCustomRangeIfEmpty(row)
      } else if (!row.customDt) {
        row.customDt = { startDate: null, endDate: null }
      }
    }

    const normalizeYYYYMMDD = function (s) {
      return (s || "").replace(/\D/g, "").slice(0, 8)
    }

    /** Custom 스케줄: 정확히 8자리 숫자 + 실제 달력 날짜(UTC)만 허용 */
    const SCHEDULE_CUSTOM_YYYYMMDD = /^\d{8}$/
    const parseValidScheduleYyyymmdd = function (raw) {
      const digits = normalizeYYYYMMDD(raw)
      if (!SCHEDULE_CUSTOM_YYYYMMDD.test(digits)) return null
      const y = parseInt(digits.slice(0, 4), 10)
      const mo = parseInt(digits.slice(4, 6), 10)
      const d = parseInt(digits.slice(6, 8), 10)
      const dt = DateTime.utc(y, mo, d)
      if (!dt.isValid || dt.toFormat("yyyyLLdd") !== digits) return null
      return digits
    }
    const scheduleCustomInclusiveDays = function (from8, to8) {
      const df = DateTime.fromFormat(from8, "yyyyLLdd", { zone: "utc" })
      const dtt = DateTime.fromFormat(to8, "yyyyLLdd", { zone: "utc" })
      return Math.floor(dtt.diff(df).as("days")) + 1
    }

    const ymdUtcToMoment = function (ymd8) {
      if (!ymd8 || ymd8.length !== 8) return null
      const m = moment.utc(ymd8, "YYYYMMDD", true)
      return m.isValid() ? m : null
    }

    const momentUtcToYmd = function (m) {
      if (!m || !moment.isMoment(m) || !m.isValid()) return ""
      return m.clone().utc().format("YYYYMMDD")
    }

    const buildCustomDtFromYmd = function (from8, to8) {
      const start = ymdUtcToMoment(parseValidScheduleYyyymmdd(from8))
      const end = ymdUtcToMoment(parseValidScheduleYyyymmdd(to8))
      if (!start || !end) {
        return { startDate: null, endDate: null }
      }
      return { startDate: start, endDate: end }
    }

    /** custom 기간 picker 기본값 (UTC, 스케줄러 dataRange와 동일한 달력 구간) */
    const defaultCustomYmdRangeForFreq = function (freq) {
      const yesterday = DateTime.utc().minus({ days: 1 })
      if (freq === "weekly") {
        const to = yesterday
        const from = to.minus({ days: 6 })
        return { from: from.toFormat("yyyyLLdd"), to: to.toFormat("yyyyLLdd") }
      }
      if (freq === "monthly") {
        const now = DateTime.utc()
        const from = now.minus({ months: 1 }).startOf("month")
        const to = now.startOf("month").minus({ days: 1 })
        return { from: from.toFormat("yyyyLLdd"), to: to.toFormat("yyyyLLdd") }
      }
      const d = yesterday.toFormat("yyyyLLdd")
      return { from: d, to: d }
    }

    const applyDefaultCustomRangeIfEmpty = function (row) {
      if (row.dataRange !== "custom") return
      const cf = parseValidScheduleYyyymmdd(row.customFrom)
      const ct = parseValidScheduleYyyymmdd(row.customTo)
      if (cf && ct) {
        row.customDt = buildCustomDtFromYmd(row.customFrom, row.customTo)
        return
      }
      const { from, to } = defaultCustomYmdRangeForFreq(row.frequency)
      row.customFrom = from
      row.customTo = to
      row.customDt = buildCustomDtFromYmd(from, to)
    }

    const syncCustomYmdFromDt = function (row) {
      const dt = row.customDt
      if (
        !dt ||
        !moment.isMoment(dt.startDate) ||
        !moment.isMoment(dt.endDate) ||
        !dt.startDate.isValid() ||
        !dt.endDate.isValid()
      ) {
        row.customFrom = ""
        row.customTo = ""
        return
      }
      row.customFrom = momentUtcToYmd(dt.startDate)
      row.customTo = momentUtcToYmd(dt.endDate)
    }

    const parseSendTimeParts = function (timeStr, fallbackTime) {
      const raw = timeStr && String(timeStr).trim() !== "" ? timeStr : fallbackTime
      const [h, m] = String(raw || "10:00").split(":")
      return {
        hour: (h || "10").padStart(2, "0"),
        minute: (m || "00").padStart(2, "0"),
      }
    }

    const buildEmailScheduleRowsFromChannel = function (emailCh) {
      const ch = emailCh || {}
      const channelSendTime = ch.sendTime || "10:00"
      const defaultOtherRowTime = "10:00"
      const freqs = ["daily", "weekly", "monthly"]
      const rows = freqs.map((freq) => {
        const src = freq === "daily" ? channelSendTime : defaultOtherRowTime
        const { hour, minute } = parseSendTimeParts(src, defaultOtherRowTime)
        return {
          frequency: freq,
          enabled: false,
          dataRange: defaultDataRangeForFreq(freq),
          hour,
          minute,
          weekdays: [false, false, false, false, false, false, false],
          daysOfMonthStr: "",
          customFrom: "",
          customTo: "",
          customDt: { startDate: null, endDate: null },
        }
      })
      const serverSchedules = ch.schedules
      if (serverSchedules && serverSchedules.length) {
        for (const s of serverSchedules) {
          const row = rows.find((r) => r.frequency === s.frequency)
          if (!row) continue
          row.enabled = !!s.enabled
          row.dataRange = s.dataRange || defaultDataRangeForFreq(s.frequency)
          const hasRowSendTime = s.sendTime != null && String(s.sendTime).trim() !== ""
          const effectiveSt = hasRowSendTime
            ? s.sendTime
            : s.frequency === "daily"
            ? channelSendTime
            : defaultOtherRowTime
          const { hour: sh, minute: sm } = parseSendTimeParts(effectiveSt, defaultOtherRowTime)
          row.hour = sh
          row.minute = sm
          row.weekdays = [false, false, false, false, false, false, false]
          ;(s.scheduleWeekdays || []).forEach((d) => {
            if (d >= 0 && d <= 6) row.weekdays[d] = true
          })
          row.daysOfMonthStr = (s.scheduleDaysOfMonth || [])
            .slice()
            .sort((a, b) => a - b)
            .join(", ")
          row.customFrom = s.customFrom || ""
          row.customTo = s.customTo || ""
          row.customDt = buildCustomDtFromYmd(row.customFrom, row.customTo)
        }
        rows.forEach(finalizeEmailScheduleRow)
        return rows
      }
      const freq = ch.scheduleFrequency || "daily"
      const row = rows.find((r) => r.frequency === freq)
      if (row) {
        row.enabled = true
        row.dataRange =
          freq === "weekly"
            ? "weekly_calendar"
            : freq === "monthly"
            ? "previous_month"
            : "previous_day"
        const { hour: lh, minute: lm } = parseSendTimeParts(channelSendTime, defaultOtherRowTime)
        row.hour = lh
        row.minute = lm
        ;(ch.scheduleWeekdays || []).forEach((d) => {
          if (d >= 0 && d <= 6) row.weekdays[d] = true
        })
        row.daysOfMonthStr = (ch.scheduleDaysOfMonth || [])
          .slice()
          .sort((a, b) => a - b)
          .join(", ")
      }
      rows.forEach(finalizeEmailScheduleRow)
      return rows
    }

    const computeLegacyFromEmailRows = function (rows) {
      const enabled = (rows || []).filter((r) => r.enabled)
      if (enabled.length === 0) {
        return {
          scheduleFrequency: "daily",
          sendTime: "10:00",
          scheduleWeekdays: [],
          scheduleDaysOfMonth: [],
        }
      }
      const order = ["daily", "weekly", "monthly"]
      const pick = order.map((f) => enabled.find((r) => r.frequency === f)).find(Boolean)
      const wd = parseInt(pick.weekdaySingle, 10)
      const weekLeg = pick.frequency === "weekly" && !isNaN(wd) && wd >= 0 && wd <= 6 ? [wd] : []
      const dom = parseInt(pick.dayOfMonthSingle, 10)
      const monthLeg =
        pick.frequency === "monthly" && !isNaN(dom) && dom >= 1 && dom <= 31 ? [dom] : []
      return {
        scheduleFrequency: pick.frequency,
        sendTime: `${pick.hour}:${pick.minute}`,
        scheduleWeekdays: weekLeg,
        scheduleDaysOfMonth: monthLeg,
      }
    }

    $scope.emailDataRangeOptions = {
      daily: ["previous_day", "last_7_days", "last_30_days"],
      weekly: ["last_7_days", "weekly_calendar", "last_30_days"],
      monthly: ["previous_month", "last_30_days", "last_90_days"],
    }

    $scope.getEmailDataRangeLabel = function (key) {
      const i18nKey = `data range ${key}`
      const s = Locale.string(i18nKey)
      return s !== i18nKey ? s : key
    }

    $scope.getEmailDataRangeOptionLabel = function (row, opt) {
      if (!row || !opt) return ""
      let base = $scope.getEmailDataRangeLabel(opt)
      const def = defaultDataRangeForFreq(row.frequency)
      if (opt === def) {
        const sufKey = "schedule data range default suffix"
        const suf = Locale.string(sufKey)
        base += suf !== sufKey ? suf : " (Default)"
      }
      return base
    }

    $scope.getEmailMonthDayOptionLabel = function (d) {
      const k = "schedule month day option"
      const s = Locale.string(k)
      if (!s || s === k) {
        return `Date ${d}`
      }
      return s.replace(/\{\{n\}\}/g, String(d))
    }

    $scope.getEmailWeekdayOptionLabel = function (day) {
      if (!day) return ""
      const s = Locale.string(day.i18nKey)
      return s !== day.i18nKey ? s : day.i18nKey
    }

    $scope.applyEmailRowTimeKey = function (row) {
      const raw = row._timeKey || "10:00"
      const parts = String(raw).split(":")
      row.hour = (parts[0] || "10").padStart(2, "0")
      row.minute = snapMinuteToScheduleGrid(parts[1] || "00")
      row._timeKey = `${row.hour}:${row.minute}`
      if ($scope.newOverviewForm) {
        $scope.newOverviewForm.$setDirty()
      }
    }

    $scope.syncEmailWeekdaySingle = function (row) {
      syncRowWeekdaysFromSingle(row)
      if ($scope.newOverviewForm) {
        $scope.newOverviewForm.$setDirty()
      }
    }

    $scope.syncEmailDayOfMonthSingle = function (row) {
      row.daysOfMonthStr = String(row.dayOfMonthSingle || 1)
      if ($scope.newOverviewForm) {
        $scope.newOverviewForm.$setDirty()
      }
    }

    /** Schedule 영역 문구·시간 표기는 프로필/UI 언어(Locale). 이메일 Language(발송 언어)와 분리 */
    const isScheduleSectionUiKorean = function () {
      const code = Locale.getLanguage() || ""
      return String(code).toLowerCase().indexOf("ko") === 0
    }

    $scope.formatEmailScheduleTimeDisplay = function (row) {
      if (!row) return ""
      if (isScheduleSectionUiKorean()) {
        return formatEmailTimeKo(row.hour, row.minute)
      }
      return formatEmailTimeEn12(row.hour, row.minute)
    }

    const escapeHtml = function (s) {
      return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;")
    }

    /** i18n 키가 없을 때만 en-US 문구로 폴백 (키는 전 로케일에 존재) */
    const scheduleSummaryHtmlTemplate = function (i18nKey, enFallback) {
      const s = Locale.string(i18nKey)
      return s !== i18nKey ? s : enFallback
    }

    const monthlyOrdinalEn = function (d) {
      const n = parseInt(d, 10) || 1
      const j = n % 10
      const k = n % 100
      if (j === 1 && k !== 11) return `${n}st`
      if (j === 2 && k !== 12) return `${n}nd`
      if (j === 3 && k !== 13) return `${n}rd`
      return `${n}th`
    }

    $scope.getEmailDataRangeSummaryPhrase = function (row) {
      if (!row) return ""
      const k = `schedule summary data phrase ${row.dataRange}`
      const s = Locale.string(k)
      if (s !== k) return s
      return $scope.getEmailDataRangeLabel(row.dataRange)
    }

    $scope.getEmailScheduleRowSummaryHtml = function (row) {
      if (!row) {
        return ""
      }
      const timeDisp = escapeHtml($scope.formatEmailScheduleTimeDisplay(row))
      const dataPhrase = escapeHtml($scope.getEmailDataRangeSummaryPhrase(row))
      const dayNameKeys = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ]

      const fbDaily = "Report will be sent <strong>daily at {{time}}</strong> ({{data}})."
      const fbWeekly =
        "Report will be sent <strong>weekly on {{day}} at {{time}}</strong> ({{data}})."
      const fbMonthly =
        "Report will be sent <strong>monthly on the {{nth}} at {{time}}</strong> ({{data}})."

      if (row.frequency === "daily") {
        const tpl = scheduleSummaryHtmlTemplate("schedule summary daily html", fbDaily)
        return $sce.trustAsHtml(tpl.replace("{{time}}", timeDisp).replace("{{data}}", dataPhrase))
      }

      if (row.frequency === "weekly") {
        const idx = parseInt(row.weekdaySingle, 10)
        const key = dayNameKeys[idx] || "monday"
        const dn = Locale.string(key)
        const dayName = escapeHtml(dn !== key ? dn : key)
        const tpl = scheduleSummaryHtmlTemplate("schedule summary weekly html", fbWeekly)
        return $sce.trustAsHtml(
          tpl
            .replace("{{day}}", dayName)
            .replace("{{time}}", timeDisp)
            .replace("{{data}}", dataPhrase)
        )
      }

      if (row.frequency === "monthly") {
        const d = parseInt(row.dayOfMonthSingle, 10) || 1
        const nthRaw = isScheduleSectionUiKorean() ? `${d}일` : monthlyOrdinalEn(d)
        const nth = escapeHtml(nthRaw)
        const tpl = scheduleSummaryHtmlTemplate("schedule summary monthly html", fbMonthly)
        return $sce.trustAsHtml(
          tpl.replace("{{nth}}", nth).replace("{{time}}", timeDisp).replace("{{data}}", dataPhrase)
        )
      }

      return ""
    }

    $scope.isKoreanStore = () => $scope.form?.country === "KR"
    $scope.shouldShowAddressSearch = function () {
      return $scope.isKoreanStore() && $scope.roadNameAPIKey !== "juso-roadname-api-key"
    }

    $scope.openNewOverviewDlg = function (storeData) {
      const item = storeData.store || storeData
      $scope.isOpenInputDlg = false
      $scope.isOpenVirtualFootfall = false
      $scope.isOpenScheduleForm = false
      $scope.newOverview = _defaultNewOverview(item)

      $scope._newOverview = {
        storeName: item.name,
      }

      NewOverviewSrv.Addressbook.getByStore(
        { id: item._id },
        function (res) {
          for (const recipient of res.data.contents) {
            if (recipient.email && recipient.email.trim() !== "") {
              $scope.newOverview.channels.email.recipients.push({
                id: recipient.id,
                email: recipient.email,
                group: recipient.group,
                groupId: recipient.groupId,
                memo: recipient.memo,
              })
            }
          }
        },
        (_err) => ($scope.newOverview.channels.email.recipients = [])
      )

      NewOverviewSrv.Store.get(
        { id: item._id, _: Date.now() },
        function (res) {
          const newOverview = res != null ? res.toJSON() : undefined
          $scope.newOverview = _.merge($scope.newOverview, newOverview)

          if (!$scope.newOverview.channels.email.attachments) {
            $scope.newOverview.channels.email.attachments = []
          }

          $scope.emailAttachments = {
            screenshot: false,
            pdf: false,
          }

          $scope.newOverview.channels.email.attachments.forEach((attachment) => {
            if (attachment.category === "screenshot") {
              $scope.emailAttachments.screenshot = true
            } else if (attachment.category === "pdf") {
              $scope.emailAttachments.pdf = true
            }
          })

          // KakaoTalk 관련 설정
          $scope.kakaoReport_active = $scope.newOverview.channels.kakao.active || false
          $scope.kakaoReport_locale = _.find($scope.languageList, {
            code: $scope.newOverview.channels.kakao.locale.toUpperCase(),
          })
          const [kakaoHour, kakaoMinute] = $scope.newOverview.channels.kakao.sendTime.split(":")
          $scope.kakaoReportTime = { hour: kakaoHour, minute: kakaoMinute }

          // Email 관련 설정
          $scope.emailReport_active = $scope.newOverview.channels.email.active || false
          $scope.emailReport_locale = _.find($scope.languageList, {
            code: $scope.newOverview.channels.email.locale.toUpperCase(),
          })
          $scope.emailScheduleRows = buildEmailScheduleRowsFromChannel(
            $scope.newOverview.channels.email
          )

          return $scope.newOverviewForm.$setPristine()
        },
        (_err) => $scope.newOverviewForm.$setPristine()
      )

      $scope.isOpenNewOverviewDlg = true
      return $anchorScroll()
    }

    $scope.addEmailRecipient = function () {
      if (!$scope.newOverview.channels.email.recipients) {
        $scope.newOverview.channels.email.recipients = []
      }

      $scope.newOverview.channels.email.recipients.push({
        email: "",
        memo: "",
      })

      $scope.newOverviewForm.$setDirty()
    }

    $scope.removeEmailRecipient = function (index) {
      $scope.newOverview.channels.email.recipients.splice(index, 1)
      $scope.newOverviewForm.$setDirty()
    }

    $scope.submitNewOverview = function (newOverview) {
      // KakaoTalk 관련 설정
      newOverview.channels.kakao.active = $scope.kakaoReport_active || false
      newOverview.channels.kakao.locale =
        $scope.kakaoReport_locale != null ? $scope.kakaoReport_locale.code : undefined
      const [kakaoLang, kakaoRegion] = newOverview.channels.kakao.locale.split("-")
      newOverview.channels.kakao.locale = `${kakaoLang.toLowerCase()}-${kakaoRegion.toUpperCase()}`
      newOverview.channels.kakao.sendTime = `${$scope.kakaoReportTime.hour}:${$scope.kakaoReportTime.minute}`

      // Email 관련 설정
      newOverview.channels.email.active = $scope.emailReport_active || false
      newOverview.channels.email.locale =
        $scope.emailReport_locale != null ? $scope.emailReport_locale.code : undefined
      const [emailLang, emailRegion] = newOverview.channels.email.locale.split("-")
      newOverview.channels.email.locale = `${emailLang.toLowerCase()}-${emailRegion.toUpperCase()}`

      newOverview.channels.email.schedules = ($scope.emailScheduleRows || []).map((row) => {
        const wd = parseInt(row.weekdaySingle, 10)
        const weekDaysArr =
          row.frequency === "weekly" && !isNaN(wd) && wd >= 0 && wd <= 6 ? [wd] : []
        const dom = parseInt(row.dayOfMonthSingle, 10)
        const monthDaysArr =
          row.frequency === "monthly" && !isNaN(dom) && dom >= 1 && dom <= 31 ? [dom] : []
        return {
          frequency: row.frequency,
          enabled: !!row.enabled,
          dataRange: row.dataRange,
          sendTime: `${row.hour}:${row.minute}`,
          scheduleWeekdays: weekDaysArr,
          scheduleDaysOfMonth: monthDaysArr,
          customFrom:
            row.dataRange === "custom"
              ? parseValidScheduleYyyymmdd(row.customFrom) || undefined
              : undefined,
          customTo:
            row.dataRange === "custom"
              ? parseValidScheduleYyyymmdd(row.customTo) || undefined
              : undefined,
        }
      })
      const leg = computeLegacyFromEmailRows($scope.emailScheduleRows)
      newOverview.channels.email.scheduleFrequency = leg.scheduleFrequency
      newOverview.channels.email.sendTime = leg.sendTime
      newOverview.channels.email.scheduleWeekdays = leg.scheduleWeekdays
      newOverview.channels.email.scheduleDaysOfMonth = leg.scheduleDaysOfMonth

      // TODO: 차후 option 설정 추가
      newOverview.channels.email.attachments = []
      if ($scope.emailAttachments && $scope.emailAttachments.screenshot) {
        newOverview.channels.email.attachments.push({
          category: "screenshot",
          options: {},
        })
      }
      if ($scope.emailAttachments && $scope.emailAttachments.pdf) {
        newOverview.channels.email.attachments.push({
          category: "pdf",
          options: {},
        })
      }

      if (!newOverview.channels.email.recipients) {
        newOverview.channels.email.recipients = []
      }

      const recipients = newOverview.channels.email.recipients.map((recipient) => ({
        ...recipient,
        storeId: newOverview._storeId,
      }))

      NewOverviewSrv.Addressbook.updateBulk({ id: newOverview._storeId }, recipients)

      return NewOverviewSrv.Store.update(
        { id: newOverview._storeId },
        {
          _id: newOverview._id,
          orgType: newOverview._orgType,
          _orgId: newOverview._orgId,
          channels: newOverview.channels,
        },
        (_res) => ($scope.isOpenNewOverviewDlg = false)
      )
    }

    $scope.openVirtualFootfall = function (store) {
      $scope.isOpenInputDlg = false
      $scope.isOpenVirtualFootfall = true
      return ($scope.selectedStore = store)
    }

    $scope.openScheduleForm = function (store) {
      $scope.isOpenInputDlg = false
      $scope.isOpenScheduleForm = true
      return ($scope.selectedStore = store)
    }
    $scope.apprModes = ["none", "appr", "algoA", "algoB"]
    $scope.banNameList = _.join(_.map(kStandardLabels, "i18nKey"), ",")
    $scope.kDefaultStoreGroupName = UtilSrv.getDefaultStoreGroupName()

    $scope.itemName = Locale.string("Store")
    $scope.companyPlaceholder = Locale.string("choose a company")
    $scope.labelTooltip = Locale.string("first label is always active")
    const strActive = Locale.string("Active")
    const strInactive = Locale.string("Inactive")
    $scope.inputDlgTitle = "Create"
    let original = null

    const config = $rootScope.globalConfig
    $scope.uploadUrl = `${config.apipath}/store/thumbnail`

    $scope.MIN_LABEL = 5
    $scope.emailWeekdays = [
      { idx: 0, i18nKey: "sun" },
      { idx: 1, i18nKey: "mon" },
      { idx: 2, i18nKey: "tue" },
      { idx: 3, i18nKey: "wed" },
      { idx: 4, i18nKey: "thu" },
      { idx: 5, i18nKey: "fri" },
      { idx: 6, i18nKey: "sat" },
    ]
    $scope.hours = Array.from({ length: 24 }, (_, i) => {
      return i.toString().padStart(2, "0")
    })

    $scope.minutes = ["00", "10", "20", "30", "40", "50"]
    $scope.open = {}
    $scope.close = {}
    $scope.seedCounterList = []
    $scope.companySelector = { selected: {} }

    $scope.regionOptions = [
      "서울권",
      "인천권",
      "경기권",
      "강원권",
      "충청권",
      "전라권",
      "경상권",
      "제주권",
    ]

    const getLabelColors = (index) => getColors(index, "label")

    const setDatetimeConfiguration = function (pageOptions, pickerOptions) {
      if (!pageOptions) {
        return
      }
      if (!pickerOptions) {
        return
      }

      const configuration = DateTimeSrv.getThisYearConfiguration()
      pageOptions.dt = configuration.dt
      return (pickerOptions.rangeMaxDate = configuration.maxDate)
    }

    // Default Configuration
    $scope.pageOptions = {}
    $scope.pickerOptions = {
      sampling: "day",
      rangeMaxDate: moment(),
    }
    setDatetimeConfiguration($scope.pageOptions, $scope.pickerOptions)

    $scope.emailCustomPickerOptions = {
      sampling: "day",
      rangeMaxDate: moment.utc().subtract(1, "day").endOf("day"),
    }

    $scope.onEmailDataRangeChange = function (row) {
      if (row.dataRange === "custom") {
        applyDefaultCustomRangeIfEmpty(row)
      }
      if ($scope.newOverviewForm) {
        $scope.newOverviewForm.$setDirty()
      }
    }

    $scope.onEmailCustomRangeChange = function (row, date) {
      if (date) {
        row.customDt = date
      }
      syncCustomYmdFromDt(row)
      if ($scope.newOverviewForm) {
        $scope.newOverviewForm.$setDirty()
      }
    }

    const DEFAULT_TIMEZONE = "Europe/London"

    $scope.$watch("showSelectedOrganization", (value) => $scope.reload())

    $scope.selectCompany = function (selectedCompany) {
      if ($scope.inputDlgTitle === "Create") {
        $scope.form.heatmapWeight.pass =
          (selectedCompany.heatmapWeight != null
            ? selectedCompany.heatmapWeight.pass
            : undefined) != null
            ? selectedCompany.heatmapWeight != null
              ? selectedCompany.heatmapWeight.pass
              : undefined
            : 1
        $scope.form.heatmapWeight.dwell =
          (selectedCompany.heatmapWeight != null
            ? selectedCompany.heatmapWeight.dwell
            : undefined) != null
            ? selectedCompany.heatmapWeight != null
              ? selectedCompany.heatmapWeight.dwell
              : undefined
            : 1

        if (selectedCompany?.policy?.snapshot) {
          $scope.form.policy.snapshot = _.cloneDeep(selectedCompany.policy.snapshot)
        } else {
          $scope.form.policy.snapshot = {
            kind: "schedule",
            schedule: {
              weekdays: [1],
              days: [],
              timeKind: "open",
              absolute: "09:00:00",
              open: 600,
            },
          }
        }
      }
      // reflect currently selected company for template usage (company ai-report status)
      $scope.vm.company = selectedCompany
    }

    $scope.getSelectedAgency = function () {
      const companyId = $scope.form && $scope.form._companyId
      if (companyId && $scope.companies && $scope.agencies) {
        const company = _.find($scope.companies, { _id: companyId })
        if (company && company._agencyId) {
          return _.find($scope.agencies, { _id: company._agencyId })
        }
      }
      return null
    }

    $scope.getSelectedCompany = function () {
      const companyId = $scope.form && $scope.form._companyId
      if (companyId && $scope.companies) {
        return _.find($scope.companies, { _id: companyId })
      }
      return null
    }

    $scope.getNoPersonalData = function () {
      const selectedAgency = $scope.getSelectedAgency()
      return selectedAgency?.policy?.noPersonalData ?? true
    }

    const syncCountryFromTimezone = function () {
      if (!$scope.form) {
        return
      }
      if ($scope.form.timezone) {
        $scope.form.country = getCountryCodeFromTimezone($scope.form.timezone)
      } else {
        $scope.form.country = null
      }
    }

    $scope.getUsePrivacyLaw = function () {
      const selectedCompany = $scope.getSelectedCompany()
      if (selectedCompany?.policy?.privacyLaw) {
        if (
          selectedCompany.policy.privacyLaw.companyAdmin ||
          selectedCompany.policy.privacyLaw.superAdmin
        ) {
          return true
        }
      }
      return false
    }

    const initialForm = function () {
      const form = {
        name: "",
        timezone: "",
        region: "",
        retailDistributionChannel: "",
        location: "",
        tel: "",
        businessType: "store",
        company: "",
        companyVirtualFF: false,
        active: true,
        labels: [],
        specialLabels: [],
        activeForm: false,
        gates: [],
        schedule: {
          businessHours: {
            active: false,
            dayOfWeek: [
              {
                open: "00:00",
                close: "24:00",
              },
            ],
          },
          convert: {
            footfall: false,
            trafficHeatmap: false,
          },
          abnTimePeriod: $scope.storeFormCtrl.abnTimePeriod.toForm(),
        },
        seedCounterOfGA: "Footfall Entrance",
        addDefaultStoreGroup: true,
        heatmapWeight: {
          pass: 1,
          dwell: 1,
        },
        maintenanceMode: {
          agency: false,
          company: false,
        },
        weather: {
          locationId: "",
        },
        apprAnalysis: {
          mode: "none",
          minSimilarity: 76,
          staffRule: "longStay",
          staffStay: 2, // 2 hours
          filters: "",
        },
        aiReport: {
          active: false,
        },
        address: "",
        subaddress: "",
        policy: {
          snapshot: {
            kind: "schedule",
            schedule: {
              weekdays: [1],
              days: [],
              timeKind: "open",
              absolute: "09:00:00",
              open: 600,
            },
          },
        },
        serviceBeginDate: "",
        serviceEndDate: "",
        customOverviewCode: "",
      }

      kStandardLabels.forEach(
        (slabel, idx) =>
          (form.specialLabels[idx] = {
            name: slabel.name,
            color: slabel.color,
            rgbcolor: `rgb(${slabel.color})`,
            weights: slabel.weights,
          })
      )

      for (
        let i = 0, end = $scope.MIN_LABEL, asc = 0 <= end;
        asc ? i < end : i > end;
        asc ? i++ : i--
      ) {
        var labelColor = getLabelColors(i)
        form.labels[i] = {
          name: `Label ${i + 1}`,
          color: labelColor,
          active: false,
          rgbcolor: `rgb(${labelColor})`,
          weights: getDefaultWeight(),
        }
      }

      $scope.thumbnailUrl = ""
      $scope.companySelector.selected =
        ($scope.companies != null ? $scope.companies.length : undefined) === 1
          ? $scope.companies[0]
          : _.find($scope.companies, { _id: Auth.clientInfo("admin.stores.lastSelectedCompanyId") })
      $scope.vm.company = $scope.companySelector.selected
      $scope.form_create.$setPristine()
      $scope.errorMessage = ""
      $scope.messageOfSubsampling = {}
      $scope.showConvertMessage = false

      return form
    }

    const getDateTime = function (date) {
      if (date) {
        return new Date(date)
      } else {
        return ""
      }
    }

    const normalizeServiceEndDateForSubmit = function (store) {
      if (!store || !store.serviceEndDate) {
        return
      }

      const timezone = store.timezone || undefined
      try {
        const serviceEndMoment = timezone
          ? moment.tz(store.serviceEndDate, timezone)
          : moment(store.serviceEndDate)

        store.serviceEndDate = serviceEndMoment.endOf("day").toDate()
      } catch (err) {
        console.warn("Failed to normalize store.serviceEndDate", err)
      }
    }

    const _defaultNewOverview = function (item) {
      const newOverview = {
        _storeId: item._id,
        channels: {
          kakao: {
            active: false,
            locale: "ko-KR",
            sendTime: "10:00",
          },
          email: {
            active: false,
            locale: "ko-KR",
            scheduleFrequency: "daily",
            scheduleWeekdays: [],
            scheduleDaysOfMonth: [],
            sendTime: "10:00",
            recipients: [],
            attachments: [],
          },
        },
      }

      $scope.kakaoReport_active = newOverview.channels.kakao.active
      $scope.kakaoReport_locale = _.find($scope.languageList, {
        code: newOverview.channels.kakao.locale.toUpperCase(),
      })

      $scope.emailReport_active = newOverview.channels.email.active
      $scope.emailReport_locale = _.find($scope.languageList, {
        code: newOverview.channels.email.locale.toUpperCase(),
      })
      $scope.emailScheduleRows = buildEmailScheduleRowsFromChannel(newOverview.channels.email)
      $scope.emailAttachments = {
        screenshot: false,
        pdf: false,
      }

      return newOverview
    }

    $scope.getScheduleDayOfMonthHint = function () {
      const s = Locale.string("schedule day of month hint")
      return s !== "schedule day of month hint"
        ? s
        : "Enter days separated by commas (e.g. 1, 15, 31)"
    }

    $scope.getEmailRowConfigError = function (row) {
      if (!row || !row.enabled) return null

      if (row.dataRange === "custom") {
        const cf = parseValidScheduleYyyymmdd(row.customFrom)
        const ct = parseValidScheduleYyyymmdd(row.customTo)
        if (!cf || !ct || cf > ct || scheduleCustomInclusiveDays(cf, ct) > 366) {
          const s = Locale.string("schedule custom range invalid")
          return s !== "schedule custom range invalid"
            ? s
            : "Select a valid custom date range (max 1 year)"
        }
      }

      if (row.frequency === "weekly") {
        const wd = parseInt(row.weekdaySingle, 10)
        if (!isNaN(wd) && wd >= 0 && wd <= 6) return null
        const s = Locale.string("schedule please select weekly")
        return s !== "schedule please select weekly" ? s : "Select at least one day of the week"
      }
      if (row.frequency === "monthly") {
        const dom = parseInt(row.dayOfMonthSingle, 10)
        if (!isNaN(dom) && dom >= 1 && dom <= 31) return null
        const s = Locale.string("schedule please enter monthly")
        return s !== "schedule please enter monthly"
          ? s
          : "Enter day(s) of the month (e.g. 1, 15, 31)"
      }
      return null
    }

    $scope.getEmailDuplicateSendTimeWarning = function () {
      if (!$scope.emailReport_active || !$scope.emailScheduleRows) return ""
      const enabled = $scope.emailScheduleRows.filter((r) => r.enabled)
      const seen = new Set()
      for (const r of enabled) {
        const k = `${r.hour}:${r.minute}`
        if (seen.has(k)) {
          return Locale.string("schedule duplicate send time warning")
        }
        seen.add(k)
      }
      return ""
    }

    $scope.hasEmailScheduleConfigErrors = function () {
      if (!$scope.emailReport_active || !$scope.emailScheduleRows) return false
      for (let i = 0; i < $scope.emailScheduleRows.length; i++) {
        if ($scope.getEmailRowConfigError($scope.emailScheduleRows[i])) return true
      }
      return false
    }

    const getTimezone = function () {
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? DEFAULT_TIMEZONE
      if (timezone == "UTC") {
        timezone = DEFAULT_TIMEZONE
      }
      return timezone
    }

    $scope.canSubmit = function () {
      if (!$scope.isOpenInputDlg) {
        return false
      }

      $scope.form._companyId =
        $scope.companySelector.selected != null ? $scope.companySelector.selected._id : undefined
      if ($scope.isCopyStore()) {
        return $scope.form._companyId !== original._companyId
      } else {
        return $scope.form_create.$valid && !angular.equals($scope.form, original)
      }
    }

    $scope.submitForm = function ($event) {
      let field, value
      for (field in $scope.storeFormCtrl) {
        value = $scope.storeFormCtrl[field]
        if (value.beforeSubmit != null && !value.beforeSubmit($event)) {
          $event.preventDefault()
          return
        }
      }
      const dbColorPattern = /\d+,\d+,\d+/
      $scope.form.labels.forEach(function (label) {
        label.color = dbColorPattern.exec(label.rgbcolor)
        if (label.color) {
          label.color = label.color[0]
        }
      })

      $scope.form.specialLabels.forEach(function (slabel) {
        slabel.color = dbColorPattern.exec(slabel.rgbcolor)
        if (slabel.color) {
          slabel.color = slabel.color[0]
        }
      })

      if ($scope.form.weather.locationId === "") {
        $scope.form.weather.locationId = null
      }

      // UCNT-7031: 서비스 종료일을 서비스 기간에 포함
      normalizeServiceEndDateForSubmit($scope.form)

      let doSubmit = null
      if ($scope.inputDlgTitle === "Create") {
        doSubmit = $scope.createItem.bind(null, $scope.form)
      } else if ($scope.isCopyStore()) {
        delete $scope.form._id
        delete $scope.form.id
        doSubmit = $scope.createItem.bind(null, $scope.form)
      } else {
        doSubmit = $scope.updateItem.bind(null, $scope.form)
      }

      return doSubmit().then((store) =>
        (() => {
          const result = []
          for (field in $scope.storeFormCtrl) {
            value = $scope.storeFormCtrl[field]
            if (value.afterSubmit != null) {
              $scope.form._id = store._id
              result.push(value.afterSubmit())
            } else {
              result.push(undefined)
            }
          }
          return result
        })()
      )
    }

    const makeErrorMessage = function (errorObj) {
      if (!errorObj.body) {
        return errorObj.statusText
      } else if (errorObj.data.code) {
        switch (errorObj.data.code) {
          case 11000:
            return Locale.string("msg_error_storename_duplicated")
          default:
            return errorObj
        }
      } else {
        return "Unknwon error"
      }
    }

    $scope.createItem = (item) =>
      new Promise((resolve, reject) =>
        StoreAdminSrv.save(
          item,
          (sobj, res) =>
            _uploadThumbnail(sobj._id, function (err, data) {
              if (err) {
                console.error(err.message)
              }

              $scope.reload(false).then(() => HeaderSrv.emitter.reload())
              $scope.isOpenInputDlg = false
              Auth.clientInfo(
                "admin.stores.lastSelectedCompanyId",
                $scope.companySelector.selected != null
                  ? $scope.companySelector.selected._id
                  : undefined
              )

              if ($scope.form.addDefaultStoreGroup) {
                return getDefaultStoreGroup(item._companyId)
                  .then((group) => addDefaultStoreGroup(group._id, sobj._id))
                  .then(function () {
                    $scope.$broadcast("reload_storegroup")
                    return resolve(sobj)
                  })
                  .catch((err) => reject(err))
              } else {
                return resolve(sobj)
              }
            }),

          function (error) {
            if (error) {
              $scope.errorMessage = makeErrorMessage(error)
            }
            return reject(error)
          }
        )
      )

    var getDefaultStoreGroup = (companyId) =>
      ApiSrv.getAllStoreGroup({ isCache: false, companyId }).then((groups) =>
        _.find(groups, (group) => UtilSrv.isDefaultStoreGroup(group.name))
      )

    var addDefaultStoreGroup = (groupId, storeId) =>
      new Promise((resolve, reject) =>
        StoreGroupSrv.addMember(
          {
            id: groupId,
            storeId,
          },
          (res) => resolve(),
          (err) => reject(err)
        )
      )

    $scope.showAdditionalOperation = () =>
      $scope.inputDlgTitle === "Create" && $scope.companySelector.selected

    $scope.updateItem = function (item) {
      if (!$scope.thumbnailFiles) {
        delete item.thumbnail
      }
      return new Promise((resolve, reject) =>
        async.waterfall(
          [
            (step) =>
              StoreAdminSrv.update(
                { id: item._id },
                item,
                function (sobj, res) {
                  if (Array.from(me.favorite.stores).includes(item._id)) {
                    ApiSrv.getFavoriteStores({ isCache: false })
                  }
                  return step(null, sobj)
                },
                function (error) {
                  if (error) {
                    return step(makeErrorMessage(error))
                  } else {
                    return step(null, null)
                  }
                }
              ),
          ],
          function (error, sobj) {
            if (error) {
              reject(error)
              return ($scope.errorMessage = error)
            }

            return _uploadThumbnail(sobj._id, function (err, data) {
              $scope.reload(false).then(() => HeaderSrv.emitter.reload())
              const store = ApiSrv.getStore({ id: item._id })
              resolve(store)
              $scope.isOpenInputDlg = false
              if (err) {
                return console.error(err.message)
              }
            })
          }
        )
      )
    }

    $scope.isCompleteList = (list) => list && (list != null ? list.length : undefined) > 1

    $scope.addCustomLabel = function () {
      const { length } = $scope.form.labels
      const labelColor = getLabelColors(length)

      return $scope.form.labels.push({
        name: `Label ${length + 1}`,
        color: labelColor,
        active: true,
        rgbcolor: `rgb(${labelColor})`,
        weights: getDefaultWeight(),
      })
    }

    $scope.sortConf = {
      group: "customLabels",
      animation: 150,
      handle: ".drag-handle",
    }

    $scope.isSavedCustomLabel = (label) => !_.isUndefined(label != null ? label._id : undefined)

    $scope.cancelCustomLabel = (index) => _.pullAt($scope.form.labels, index)

    $scope.openInputDlg = function (item, copyStore) {
      $scope.vm.industryExpanded = false
      if (copyStore == null) {
        copyStore = false
      }
      if (
        !$scope.companies ||
        ($scope.companies != null ? $scope.companies.length : undefined) === 0
      ) {
        $window.alert(Locale.string("company list is empty"))
      }

      if ($scope.notiFormCtrl != null ? $scope.notiFormCtrl.isOpened : undefined) {
        $scope.notiFormCtrl.closeDialog()
      }
      if ($scope.isOpenNewOverviewDlg) {
        $scope.isOpenNewOverviewDlg = false
      }
      if ($scope.isOpenVirtualFootfall) {
        $scope.isOpenVirtualFootfall = false
      }
      if ($scope.isOpenScheduleForm) {
        $scope.isOpenScheduleForm = false
      }

      $scope.isOpenInputDlg = true
      if (item != null) {
        $scope.form = _.cloneDeep(item.data)
        $scope.form.serviceBeginDate = getDateTime($scope.form.serviceBeginDate)
        $scope.form.serviceEndDate = getDateTime($scope.form.serviceEndDate)
        $scope.form.schedule.abnTimePeriod = $scope.storeFormCtrl.abnTimePeriod.toForm(
          $scope.form.schedule.abnTimePeriod
        )
        $scope.thumbnailUrl = `${item.thumbnailUrl("small")}`
        $scope.companySelector.selected = _.find($scope.companies, { _id: item._companyId })
        $scope.vm.company = _.find($scope.companies, { _id: item._companyId })
        delete $scope.form.createdAt
        $scope.form_create.$setDirty()
        $scope.errorMessage = ""
        $scope.messageOfSubsampling = {}
        $scope.showConvertMessage = false
        $scope.form.labels.forEach(function (label) {
          if (label.color) {
            label.rgbcolor = `rgb(${label.color})`
          }
          if (!label.weights) {
            label.weights = getDefaultWeight()
          }
        })
        if ($scope.form.specialLabels.length === 5) {
          // patch code: add group count label when loading store which is created before V2.30
          $scope.form.specialLabels[5] = {
            name: kStandardLabels[5].name,
            color: kStandardLabels[5].color,
          }
        }
        $scope.form.specialLabels.forEach(function (slabel) {
          if (slabel.color) {
            slabel.rgbcolor = `rgb(${slabel.color})`
          }
          if (!slabel.weights) {
            slabel.weights = getDefaultWeight()
          }
        })

        if (($scope.form.weather != null ? $scope.form.weather.locationId : undefined) == null) {
          $scope.form.weather = { locationId: "" }
        }

        if (!$scope.form.aiReport) {
          $scope.form.aiReport = { active: false }
        }

        $scope.updateSeedCounterList()
        if (copyStore) {
          $scope.inputDlgTitle = "Copy Store"
        } else {
          $scope.inputDlgTitle = "Update"
        }
      } else {
        $scope.inputDlgTitle = "Create"
        $scope.form = initialForm()
        $scope.form.timezone = getTimezone()
        $scope.updateSeedCounterList()
        // default selected company for create
        $scope.vm.company = $scope.companySelector.selected
      }

      syncCountryFromTimezone()

      $scope.getStandardLabelName = function (name) {
        const label = _.find(kStandardLabels, ["name", name])
        return Locale.string(label.i18nKey)
      }

      $scope.open = _parseTime(
        ($scope.form.schedule.businessHours.dayOfWeek[0] != null
          ? $scope.form.schedule.businessHours.dayOfWeek[0].open
          : undefined) != null
          ? $scope.form.schedule.businessHours.dayOfWeek[0] != null
            ? $scope.form.schedule.businessHours.dayOfWeek[0].open
            : undefined
          : "00:00"
      )
      $scope.close = _parseTime(
        ($scope.form.schedule.businessHours.dayOfWeek[0] != null
          ? $scope.form.schedule.businessHours.dayOfWeek[0].close
          : undefined) != null
          ? $scope.form.schedule.businessHours.dayOfWeek[0] != null
            ? $scope.form.schedule.businessHours.dayOfWeek[0].close
            : undefined
          : "24:00"
      )

      original = _.cloneDeep($scope.form) //angular.copy $scope.form

      setDatetimeConfiguration($scope.pageOptions, $scope.pickerOptions)
    }

    var _parseTime = function (tm) {
      const _tm = tm.split(":")
      return {
        timeFunc() {
          return this.hour + ":" + this.minute
        },
        hour: _tm[0],
        minute: _tm[1],
      }
    }

    const deleteStore = (storeId) =>
      StoreAdminSrv.delete({ id: storeId }).$promise.catch(function (err) {
        if (err.data != null) {
          return ($scope.errorMessage = err.data)
        }
      })

    // Todo
    // Need to add removing data by storeId
    $scope.removeItem = (item) =>
      ApiSrv.getCameraOfStore({ id: item._id, isCache: false }).then(
        function (cameras) {
          const opt = {
            template: "components/popup/popup-confirm.html",
            closeByEscape: true,
            closeByDocument: true,
            showClose: false,
            className: "ngdialog-theme-default popup-confirm",
            controller: "ucPopupConfirmCtrl",
          }

          if ((cameras != null ? cameras.length : undefined) > 0) {
            opt.data = {
              title: Locale.string("Warning") + "!",
              message: Locale.string("msg_confirm_body_remove_store"),
            }
          } else {
            opt.data = { title: Locale.string("msg_confirm_remove_store") }
          }

          return ngDialog
            .openConfirm(opt)
            .then(function () {
              showLoading("delete_store")

              if ((cameras != null ? cameras.length : undefined) > 0) {
                return Promise.mapSeries(cameras, (camera) =>
                  CameraDeleteSrv.deleteData(camera).then(() =>
                    CameraDeleteSrv.deleteCamera(camera._id)
                  )
                )
              }
            })
            .then(() => deleteStore(item._id))
            .then(function () {
              $scope.reload(false).then(() => HeaderSrv.emitter.reload())
              $scope.$broadcast("reload_storegroup")
              return hideLoading("delete_store")
            })
        },
        function (err) {
          if (err.data != null) {
            return ($scope.errorMessage = err.data)
          }
        }
      )

    $scope.reload = function (isCache) {
      if (isCache == null) {
        isCache = true
      }

      return Promise.all([
        ApiSrv.getAllCompany({ isCache }),
        ApiSrv.getAllStore({ isCache: isCache }),
        ApiSrv.getAllAgency({ isCache: isCache }),
        ApiSrv.getAllCamera({ isCache: isCache }),
      ])
        .then((params) =>
          HeaderSrv.fetchCurrentStore().then(function (orgInfo) {
            const companies = params[0]
            const stores = params[1]
            const agencies = params[2]
            $scope.agencies = agencies
            $scope.companies = companies.map(function (c) {
              c.indexName = `${c.name} [${c.index}]`
              return c
            })
            let storeList
            if ($scope.showSelectedOrganization) {
              storeList = $filter("filter")(stores, function (store) {
                switch (orgInfo.orgType) {
                  case "company":
                    return orgInfo._id === store._companyId
                  case "storegroup":
                    return orgInfo.storeList.indexOf(store._id) !== -1
                  case "store":
                    return orgInfo._id === store._id
                  default:
                    return false
                }
              })
            } else {
              storeList = stores
            }
            for (var store of Array.from(storeList)) {
              store.company = _.find($scope.companies, { _id: store._companyId })
              store.agency = _.find($scope.agencies, { _id: store.company._agencyId })
              if (store.timezone) {
                store.tzstr = moment().tz(store.timezone).format("z Z")
              }
              store.indexName = `${store.name} [${store.index}]`
            }
            return loadItems(storeList)
          })
        )
        .then(() => ApiSrv.getWeatherLocations())
        .then(function (locations) {
          $scope.weatherLocations = [{ address: Locale.string("None"), locationId: "", group: "" }]
          return ($scope.weatherLocations = $scope.weatherLocations.concat(locations))
        })
        .catch((err) => console.error(err.toString()))
    }

    var loadItems = function (items) {
      $scope.Items = items
      const _getData = function ($defer, params) {
        const sorting = $scope.row
        const count = params.count()
        $scope.pagecount = count

        $scope.filterItems = $filter("filter")($scope.Items, function (val) {
          return (
            (val?.company?.name && matchText(val.company.name, $scope.searchKeywords)) ||
            (val?.company?.officialName &&
              matchText(val.company.officialName, $scope.searchKeywords)) ||
            (val?.address && matchText(val.address, $scope.searchKeywords)) ||
            (val?.name && matchText(val.name, $scope.searchKeywords)) ||
            (val?.tel && matchText(val.tel, $scope.searchKeywords))
          )
        })

        params.total($scope.filterItems.length)
        const orderItems = $filter("orderBy")($scope.filterItems, sorting)

        const start = (params.page() - 1) * params.count()
        const end = start + params.count()
        $scope.currentPageItems = orderItems.slice(start, end)
        return $defer.resolve($scope.currentPageItems)
      }

      return ($scope.tableParams = new NgTableParams(
        { count: $scope.pagecount != null ? $scope.pagecount : 25 },
        { counts: [10, 25, 50, 100], getData: _getData }
      ))
    }

    // filter
    $scope.searchKeywords = ""
    $scope.row = "company.name"

    $scope.enterKeyword = function (keyword) {
      $scope.searchKeywords = keyword
      return loadItems($scope.Items)
    }

    $scope.order = function (rowName) {
      if ($scope.currentPageItems.length < 1) {
        return
      }
      $scope.row = rowName
      return loadItems($scope.Items)
    }

    $scope.selectImage = function (files) {
      if (!files) {
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => angular.element("#preview").attr("src", e.target.result)

      reader.readAsDataURL(files)
      return ($scope.form.activeForm = true)
    }

    var _uploadThumbnail = function (storeId, callback) {
      if (!storeId) {
        return callback({ message: "no storeId" })
      }

      if ($scope.thumbnailFiles && $scope.thumbnailFiles.type.indexOf("image/") > -1) {
        const uploadUrl = `${$scope.uploadUrl}?storeId=${storeId}`
        return Upload.upload({
          url: uploadUrl,
          file: $scope.thumbnailFiles,
        }).then(
          (resp) => callback(null),
          function (resp) {
            const err = { message: `Fail to upload thumbnail(httpcode: ${resp.status})` }
            return callback(err)
          }
        )
      } else {
        return callback(null)
      }
    }

    $scope.initializeColor = (labels) =>
      (() => {
        const result = []
        for (
          let idx = 0, end = labels.length, asc = 0 <= end;
          asc ? idx < end : idx > end;
          asc ? idx++ : idx--
        ) {
          var labelColor = getLabelColors(idx)
          result.push((labels[idx].rgbcolor = `rgb(${labelColor})`))
        }
        return result
      })()

    $scope.reload()

    $scope.updateSeedCounterList = () => {
      $scope.seedCounterList = GenderAge.getSeedCounterList($scope.form.labels)
    }

    $scope.isApprMode = function () {
      return $scope.form?.apprAnalysis.mode == "appr"
    }

    $scope.isApprAnalysisEnabled = function () {
      return !(
        !$scope.form?.apprAnalysis.mode ||
        $scope.form?.apprAnalysis.mode == "" ||
        $scope.form?.apprAnalysis.mode == "none"
      )
    }

    $scope.changeApprMode = function () {
      if (!$scope.isApprAnalysisEnabled()) {
        $scope.form.features.pathtree = false
        $scope.form.features.staytime = false
      }
    }

    $scope.unCheckMaintenanceMode = function (value) {
      if (!value) {
        $scope.form.maintenanceMode.company = false
        return ($scope.form.maintenanceMode.agency = false)
      }
    }

    $scope.getMaintenanceModeStatus = function () {
      if (
        __guard__(
          $scope.form != null ? $scope.form.maintenanceMode : undefined,
          (x) => x.company
        ) &&
        __guard__($scope.form != null ? $scope.form.maintenanceMode : undefined, (x1) => x1.agency)
      ) {
        return strActive
      } else {
        return strInactive
      }
    }

    $scope.isCopyStore = () => $scope.inputDlgTitle === "Copy Store"

    $scope.getSourceStoreName = function () {
      if (original == null) {
        return
      }

      const company = _.find($scope.companies, { _id: original._companyId })
      return `${company.name} > ${original.name}`
    }

    $scope.handleSnapshotChange = function (snapshot) {
      if ($scope.form) {
        $scope.form.policy.snapshot = snapshot
      }
    }

    $scope.applySnapshotToAllSensors = function () {
      const store = $scope.form
      StoreAdminSrv.updateFixedSnapshot({ id: store._id }, store.policy.snapshot)
        .$promise.then(function () {
          return StoreAdminSrv.update(
            { id: store._id },
            {
              policy: store.policy,
            }
          )
        })
        .then(() => {
          $scope.reload(false, () => (original.policy = _.cloneDeep(store.policy)))
        })
        .catch(function (err) {
          return console.warn("applySnapshotToAllSensors error: ", err)
        })
    }

    var showLoading = function (key) {
      angular.element(".splash").show()
      usSpinnerService.spin("spinner")
      return angular.element(".spinner").css("position", "fixed")
    }

    $scope.hideWeatherObservatory = () => {
      return $scope.isLocalgrey || ($scope.form?.timezone && $scope.form.timezone !== "Asia/Seoul")
    }

    $scope.$watch("form.timezone", (newTimezone, oldTimezone) => {
      if (newTimezone !== oldTimezone) {
        syncCountryFromTimezone()
      }
    })

    $scope.openPathTreeZoneConfigDlg = async function (item) {
      if (item) {
        $scope.pathTreeZoneSrc = `/v2/embed/admin/stores/${item._id}/path-tree/zones`
        $scope.isOpenPathTreeZoneConfigDlg = true
      }
    }

    $scope.closePathTreeZoneConfigDlg = function () {
      $scope.PathTreeZoneSrc = ""
      $scope.isOpenPathTreeZoneConfigDlg = false
    }

    $scope.PathTreeZoneMessageHandler = (event) => {
      if (event.data?.type === "PATH_TREE_ZONES_RESIZE") {
        const iframe = $element.find("iframe.path-tree-zone-config")
        iframe[0].style.height = `${event.data.height + 60}px`
      } else if (event.data?.type === "PATH_TREE_ZONES_SAVED") {
        // TODO: UCNT-6685 일정 시간 toast 메시지 표시 후 자동으로 닫기
      }
    }

    $scope.openFloorplanMapConfigDlg = async function (item) {
      if (item) {
        $scope.floorplanMapSrc = `/v2/embed/admin/stores/${item._id}/path-tree/floorplan-map`
        $scope.isOpenFloorplanMapConfigDlg = true
      }
    }

    $scope.closeFloorplanMapConfigDlg = function () {
      $scope.FloorplanMapSrc = ""
      $scope.isOpenFloorplanMapConfigDlg = false
    }

    $scope.floorplanMapMessageHandler = (event) => {
      if (event.data?.type === "FLOORPLAN_MAP_RESIZE") {
        // NOTE: floorplan map 설정 페이지는 에디터를 포함하고 있어 높이를 고정값(80vh)으로 설정 - store.scss
      } else if (event.data?.type === "FLOORPLAN_MAP_SAVED") {
        // TODO: UCNT-6685 일정 시간 toast 메시지 표시 후 자동으로 닫기
      }
    }

    $scope.findWeatherByAddress = function (address) {
      const regExp = new RegExp(address)
      for (const location of $scope.weatherLocations) {
        if (regExp.test(location.address)) {
          return location
        }
      }
      return null
    }
    $scope.findNearestWeatherLocation = function (coord) {
      if (!coord) return null
      if (coord) {
        const wgs84Coord = GeocodeSrv.toWgs84(coord)
        let nearestLocation = null
        let minDistance = Infinity
        for (const location of $scope.weatherLocations) {
          const destCoord = GeocodeSrv.toWgs84({
            lat: location.latitude,
            lon: location.longitude,
          })
          const distance = GeocodeSrv.calculateDistance(wgs84Coord, destCoord)
          if (distance < minDistance) {
            minDistance = distance
            nearestLocation = location
          }
        }
        return nearestLocation
      }
      return null
    }

    function getBestWeatherLocation(address, coord) {
      const bestWeatherLocationByAddress = address ? $scope.findWeatherByAddress(address) : null
      if (coord) {
        const utmK = GeocodeSrv.toUtmK(coord)
        const gpsCoord = utmK.toLatLng()
        const bestWeatherLocationByDistance = $scope.findNearestWeatherLocation(gpsCoord)
        return bestWeatherLocationByAddress ?? bestWeatherLocationByDistance ?? null
      }
      return bestWeatherLocationByAddress
    }

    $scope.openAddressPopup = function () {
      GeocodeSrv.openAddressPopup($scope.roadNameAPIKey, function (data) {
        $scope.$apply(function () {
          $scope.form.address = data.roadAddrPart1 || data.address
          $scope.form.subAddr = data.addrDetail
          $scope.form.region = data.region
          const bestWeatherLocation = getBestWeatherLocation(data.weatherAddress, data.coord)
          $scope.form.weather.locationId =
            bestWeatherLocation != null ? bestWeatherLocation.locationId : ""
          if (data.coord) {
            const utmK = GeocodeSrv.toUtmK(data.coord)
            const gpsCoord = utmK.toLatLng()
            $scope.form.gps = GeocodeSrv.toWgs84(gpsCoord).toString()
          }
        })
      })
    }

    hideLoading = function (key) {
      angular.element(".splash").hide()
      return usSpinnerService.stop("spinner")
    }
  }
)

App.controller("StoreAccessCtrl", function ($scope, $stateParams, $state, ApiSrv, HeaderSrv) {
  $scope.ablePermissions = ["read"]
  $scope.back = () => $state.go("app.admin.store")

  const handleOrgChange = function () {
    HeaderSrv.fetchCurrentStore().then(function (orgInfo) {
      if (orgInfo.orgType === "store") {
        if (orgInfo._id !== $stateParams.storeId) {
          $state.go("app.admin.storeAccess", { storeId: orgInfo._id })
        }
      } else {
        $state.go("app.admin.store")
      }
    })
  }

  HeaderSrv.emitter.addListener("changed", handleOrgChange)

  $scope.$on("$destroy", function () {
    HeaderSrv.emitter.removeListener("changed", handleOrgChange)
  })

  return ApiSrv.getStore({ id: $stateParams.storeId }).then(
    (res) => ($scope.store = res),
    (err) => {
      throw err
    }
  )
})

App.controller(
  "StoreAccessAccountsCtrl",
  function ($scope, $stateParams, ApiSrv, NgTableParams, Locale, StoreAccessSrv) {
    const vm = this
    vm.selectedPermission = $scope.ablePermissions[0]
    vm.header = {
      account: Locale.string("Account Name"),
      email: Locale.string("Email Address"),
    }

    const _reloadList = function () {
      if (!vm.store) {
        return
      }
      return ApiSrv.getAllAccount({ isCache: false }).then(
        function (accounts) {
          const ableList = _.reduce(
            accounts,
            function (result, item) {
              if (
                item.role.orgs.indexOf(vm.store._companyId) >= 0 &&
                (item.role != null ? item.role.group : undefined) === "store" &&
                _.findIndex(vm.store.policy.access.accounts, { _accountId: item._id }) < 0
              ) {
                result.push({
                  _id: item._id,
                  email: item.email,
                  name: Locale.fullName(item),
                })
              }
              return result
            },
            []
          )

          vm.ableList = _.sortBy(ableList, "name")
          if (!_.isEmpty(vm.ableList)) {
            return (vm.selectedAccount = vm.ableList[0])
          }
        },
        (err) => {
          throw err
        }
      )
    }

    const _getData = function ($defer, params) {
      StoreAccessSrv.get(
        {
          _: Date.now(),
          storeId: $stateParams.storeId,
        },
        function (access) {
          __guard__(vm.store != null ? vm.store.policy : undefined, (x) => (x.access = access))
          _reloadList()
          __guard__(access != null ? access.accounts : undefined, (x1) =>
            x1.forEach((item) => (item["fullName"] = Locale.fullName(item)))
          )
          return $defer.resolve(
            _.sortBy(access != null ? access.accounts : undefined, ["firstName", "lastName"])
          )
        },
        function (err) {
          console.error(`Failed get accounts from store access: ${err}`)
          throw err
        }
      )
    }

    vm.add = function () {
      if (!vm.selectedAccount) {
        return
      }

      return StoreAccessSrv.add(
        {
          storeId: $stateParams.storeId,
          accountId: vm.selectedAccount._id,
          permission: vm.selectedPermission,
          item: "account",
        },
        function (res) {
          _.remove(vm.ableList, (item) => vm.selectedAccount === item)
          vm.selectedAccount = _.first(vm.ableList)

          return vm.tableParams.reload()
        },
        (err) => {
          throw err
        }
      )
    }

    vm.setPermission = function (account, permission) {
      if (!account) {
        return
      }
      if (account.permission === permission) {
        return
      }
      return StoreAccessSrv.setPermission(
        {
          storeId: $stateParams.storeId,
          id: account._accountId,
          permission,
          item: "account",
        },
        (res) => (account.permission = res.permission),
        (err) => {
          throw err
        }
      )
    }

    vm.remove = (accountId) =>
      StoreAccessSrv.remove(
        {
          storeId: $stateParams.storeId,
          id: accountId,
          item: "account",
        },
        (res) => vm.tableParams.reload()
      )

    $scope.$watch("store", function (store) {
      if (!store) {
        return
      }
      vm.store = store
      return (vm.tableParams = new NgTableParams({}, { counts: [], getData: _getData }))
    })
  }
)

App.controller(
  "StoreAccessGroupsCtrl",
  function ($scope, $stateParams, ApiSrv, NgTableParams, Locale, StoreAccessSrv) {
    const vm = this
    vm.selectedPermission = $scope.ablePermissions[0]
    vm.header = { group: Locale.string("Group Name") }

    const _reloadList = function () {
      if (!vm.store) {
        return
      }

      return ApiSrv.getAllAccountGroup({
        isCache: false,
        companyId: vm.store._companyId,
      }).then(
        function (groups) {
          const ableList = _.reduce(
            groups,
            function (result, item) {
              if (
                _.findIndex(
                  __guard__(vm.store != null ? vm.store.policy : undefined, (x) => x.access.groups),
                  { _groupId: item._id }
                ) < 0
              ) {
                result.push({
                  _id: item._id,
                  name: item.name,
                  accountList: item.accountList,
                })
              }
              return result
            },
            []
          )

          vm.ableList = _.sortBy(ableList, "name")
          if (!_.isEmpty(vm.ableList)) {
            return (vm.selectedGroup = vm.ableList[0])
          }
        },
        (err) => {
          throw err
        }
      )
    }

    const _getData = function ($defer, params) {
      StoreAccessSrv.get(
        {
          _: Date.now(),
          storeId: $stateParams.storeId,
        },
        function (access) {
          __guard__(vm.store != null ? vm.store.policy : undefined, (x) => (x.access = access))
          _reloadList()
          return $defer.resolve(_.sortBy(access != null ? access.groups : undefined, "name"))
        },
        (err) => {
          throw err
        }
      )
    }

    vm.add = function () {
      if (!vm.selectedGroup) {
        return
      }

      return StoreAccessSrv.add(
        {
          storeId: $stateParams.storeId,
          groupId: vm.selectedGroup._id,
          permission: vm.selectedPermission,
          item: "group",
        },
        function (res) {
          _.remove(vm.ableList, (item) => vm.selectedGroup === item)
          vm.selectedGroup = _.first(vm.ableList)

          return vm.tableParams.reload()
        },
        (err) => {
          throw err
        }
      )
    }

    vm.setPermission = function (group, permission) {
      if (!group) {
        return
      }
      if (group.permission === permission) {
        return
      }
      return StoreAccessSrv.setPermission(
        {
          storeId: $stateParams.storeId,
          id: group._groupId,
          permission,
          item: "group",
        },
        (res) => (group.permission = res.permission),
        (err) => {
          throw err
        }
      )
    }

    vm.remove = (groupId) =>
      StoreAccessSrv.remove(
        {
          storeId: $stateParams.storeId,
          id: groupId,
          item: "group",
        },
        (res) => vm.tableParams.reload()
      )

    $scope.$watch("store", function (store) {
      if (!store) {
        return
      }
      vm.store = store
      return (vm.tableParams = new NgTableParams({}, { counts: [], getData: _getData }))
    })
  }
)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined
}
